<template>
  <el-dialog
    :visible="id >= 0"
    :width="isMobile ? '50%' : '30%'"
    append-to-body
    center
    :close-on-click-modal="false"
    class="edit-status-modal"
    @close="beforeClose"
  >
    <div v-if="status">
      <p>Изменить время {{ status.text }}</p>
      <el-date-picker
        v-model="dateVal"
        type="datetime"
        placeholder="Выберите дату и время"
        prefix-icon="el-icon-date"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
        default-time="12:30:00"
      />
      <el-row class="raw-btn">
        <el-button type="primary" :disabled="!dateVal" @click="setDate">
          Сохранить
        </el-button>
        <el-button type="danger" @click="deleteDate">
          Удалить запись
        </el-button>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { pickerOpt } from '@/datas/consts'
import { statuses } from '@/datas/responseStatuses'

export default {
  name: 'EditStatusModal',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    date: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      statuses,
      dateVal: '',
      pickerOptions: pickerOpt,
    }
  },
  computed: {
    status() {
      return this.id >= 0 ? this.statuses[this.id] : null
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        this.dateVal = val && this.date ? this.date : ''
      },
    },
  },
  methods: {
    beforeClose() {
      this.$emit('close')
    },
    setDate() {
      if (this.dateVal && this.status.field && this.id >= 0) {
        this.$emit('change', this.dateVal, this.status.field, this.id, 1)
        this.beforeClose()
      }
    },
    deleteDate() {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() => {
        this.$emit('change', null, this.status.field, this.status.prev)
        this.beforeClose()
      })
    },
  },
}
</script>

<style lang="sass">
.edit-status-modal
  .el-dialog__body
    margin-top: 10px
    color: #000
    *
      font-family: 'Rubik', sans-serif
    p
      font-size: 16px
      text-transform: uppercase
    .raw-btn
      margin-top: 25px
      button + button
        margin-left: 25px
</style>
